import React, { Component } from 'react';
import './DragDrop.css';
import TitleBar from '../../../titleBar/TitleBar';
// import { AYLA_ALLOWED_ROLES } from '../../../constants';
import { getOemInfo } from '../../services/testResultsService';
import NavBar from '../navBar/navBar';

class DragDrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
    };
  }

  componentDidMount() {
    getOemInfo().then((result) => {
    // get oem info is is a call to the database to retrieve the devices properties that will
    // be used for text on each card.
    /*
      This is the returned data
      body:
        data: Array(1)
          0:
            OemData: {RV750: {…}, RV750N: {…}, RV850: {…}}
            OemID: "SharkNinja"
            Properties:
                GET_Ack_Response: "9613"
                GET_Battery_Capacity: "54909677"
                GET_Charging_Status: "20459410"
                GET_Cleaning_Speed: "38620"
                GET_Device_Model_Number: "2000"
                GET_Down_Adjust: "32"
    */
      this.createPropertyCards(result);
    });
  }

    onDragStart = (e, id) => {
      e.dataTransfer.setData('id', id);
    }

    onDragOver = e => {
      e.preventDefault();
    }

    onDrop = (e, cat) => {
      const { cards } = this.state;
      const id = e.dataTransfer.getData('id');

      const properties = cards.filter((p) => {
        if (p.name === id) {
          p.category = cat;
        }
        return p;
      });
      this.setState({
        ...cards,
        properties,
      });
    }

    createPropertyCards(data) {
      const cards = [];
      const propertyArr = Object.keys(data.body.data[0].Properties);
      propertyArr.forEach((item) => {
        const laneNumber = Math.floor((Math.random() * 7) + 1);
        const cardObj = {
          category: `lane${laneNumber}`,
          name: item,
        };
        cards.push(cardObj);
      });
      this.setState({
        cards,
      });
    }

    render() {
      const { cards } = this.state;

      const devProperties = {
        lane1: [],
        lane2: [],
        lane3: [],
        lane4: [],
        lane5: [],
        lane6: [],
        lane7: []
      };

      cards.forEach(p => {
        devProperties[p.category].push(
          <div key={p.name}
            onDragStart={(e) => this.onDragStart(e, p.name)}
            draggable
            // contentEditable
            className="draggable"
          >
            <p className="property-name">{p.name}</p>
          </div>
        );
      });

      return (
        <div className="subsystem-breakdown">
          <TitleBar title="Subsystem Breakdown">
            {/* <TimeAggregation value={this.props.presistFilters.aggregate_by} /> */}
          </TitleBar>
          <NavBar />
          <div className="pageContent">
            <div className="header-container">
              <h2 className="header">Organize Your Device&apos;s Properties</h2>
            </div>
            <div>
              <div className="container-drag">
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => { this.onDrop(e, 'lane1'); }}
                >
                  <span className="task-header" contentEditable>Wifi Connectivity</span>
                  {devProperties.lane1}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane2')}
                >
                  <span className="task-header" contentEditable>Device</span>
                  {devProperties.lane2}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane3')}
                >
                  <span className="task-header" contentEditable>Gas Intake Unit</span>
                  {devProperties.lane3}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane4')}
                >
                  <span className="task-header" contentEditable>Heater Unit</span>
                  {devProperties.lane4}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane5')}
                >
                  <span className="task-header" contentEditable>Water Unit</span>
                  {devProperties.lane5}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane6')}
                >
                  <span className="task-header" contentEditable>Fan Unit</span>
                  {devProperties.lane6}
                </div>
                <div className="swimlane"
                  onDragOver={e => this.onDragOver(e)}
                  onDrop={e => this.onDrop(e, 'lane7')}
                >
                  <span className="task-header" contentEditable>Power Supply Unit</span>
                  {devProperties.lane7}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
}


export default DragDrop;
